define([
    "underscore",
    "backbone",
], function(_, Backbone) {

    // more than 4 letters domain only.
    const domainList = [
        'gmail',
        'yahoo',
        'naver',
        'hotmail',
        'hanmail',
        'icloud',
        'outlook',
        'softbank',
        'docomo',
        'daum',
        'nate',
        'ezweb',
        'nifty',
        'sina',
        'live',
        'sttradeinc',
    ];

    const that = {
        init: ({ lengthDiffMax = 0, misspelledCountMax = 2, domains= domainList}) => userEmail => {
            const userEmailDomain = that._getDomain(userEmail);
            if(domains.includes(userEmailDomain)) return [];
            if(userEmailDomain.length > 4) lengthDiffMax += 1;

            const lengthFilter = that._getLengthFilter(userEmailDomain, lengthDiffMax);
            const domainObjMapper = that._getDomainObjMapper();
            const domainComparator = that._getDomainComparator(userEmailDomain, misspelledCountMax);
            const sortFunction = that._getSortFunction();

            return domains
                .filter(lengthFilter)
                .map(domainObjMapper)
                .filter(domainComparator)
                .sort(sortFunction);
        },

        format: function() {
            const args = Array.prototype.slice.call(arguments);
            const text = args.shift();
            return text.replace(/\{(\d+)\}/g, function (match, number) {
                return typeof args[number] !== "undefined" ? args[number] : match;
            });
        },

        _getDomain: (email) => {
            // if you need to extract every letters after at(@)
            const afterAt = email.replace(/.*@/, "");
            return afterAt.split('.').length > 0 ? afterAt.split('.')[0] : '';
        },

        _getLengthFilter: (userDomain, lengthDiffMax) => (domain) => {
            const diff = userDomain.length - domain.length;
            return diff <= lengthDiffMax && diff >= -lengthDiffMax;
        },

        _getDomainObjMapper: () => (domain) => {
            return {
                suggest: domain,
                misspelledCount: 0
            }
        },

        _getDomainComparator: (userDomain, misspelledCountMax) => (domainObj) => {
            // Levenshtein Distance algorithm
            const distanceMatrix = Array(userDomain.length + 1)
                .fill(null)
                .map(() => Array(domainObj.suggest.length + 1).fill(null));

            for (let i = 0; i <= domainObj.suggest.length; i += 1) distanceMatrix[0][i] = i;
            for (let j = 0; j <= userDomain.length; j += 1) distanceMatrix[j][0] = j;

            for (let j = 1; j <= userDomain.length; j += 1) {
                for (let i = 1; i <= domainObj.suggest.length; i += 1) {
                    const indicator = domainObj.suggest[i - 1] === userDomain[j - 1] ? 0 : 1;
                    distanceMatrix[j][i] = Math.min(
                        distanceMatrix[j][i - 1] + 1,
                        distanceMatrix[j - 1][i] + 1,
                        distanceMatrix[j - 1][i - 1] + indicator
                    );
                }
            }
            domainObj.misspelledCount = distanceMatrix[userDomain.length][domainObj.suggest.length];
            return domainObj.misspelledCount <= misspelledCountMax;
        },

        _getSortFunction: () => (a,b) => {
            return a.misspelledCount - b.misspelledCount;
        }
    }

    return that;
});
